import { Reducer } from "redux";
import { GetIsAuthenticatedActionTypes, LoginActionTypes, LogoutActionTypes } from './types';

export interface AuthState {
    isAuthenticated: boolean;
}

const unloadedState: AuthState = { isAuthenticated: false };

export const authReducer: Reducer<AuthState> = (state: AuthState | undefined, action): AuthState => {
    if (!state) {
        return unloadedState;
    }

    switch (action.type) {
        case LoginActionTypes.SUCCESS:
            return { ...state, isAuthenticated: true };
        case LogoutActionTypes.SUCCESS:
            return { ...state, isAuthenticated: false };
        case GetIsAuthenticatedActionTypes.SUCCESS:
            return { ...state, isAuthenticated: true };
        case GetIsAuthenticatedActionTypes.ERROR:
            return { ...state, isAuthenticated: false };
        default:
            return state;
    }
};
